import * as React from 'react';

import { ProjectDiagramCreateClassDrawer } from 'src/containers/ProjectDiagram/components/classDrawer/ProjectDiagramCreateClassDrawer';
import { CreateMappingDialog } from 'src/containers/ProjectDiagram/components/dialogs/CreateMappingDialog';
import { ProjectDiagramCreateRelationshipDrawer } from 'src/containers/ProjectDiagram/components/relationshipDrawer/ProjectDiagramCreateRelationshipDrawer';
import { ProjectDiagramCreateSensitivePropertyGroupDrawer } from 'src/containers/ProjectDiagram/components/sensitivePropertyGroupDrawer/ProjectDiagramCreateSensitivePropertyGroupDrawer';
import { ProjectDiagramEntityDrawer } from 'src/containers/ProjectDiagram/ProjectDiagramEntityDrawer';
import { ProjectResourceDialog } from 'src/containers/ProjectResourceDialog/ProjectResourceDialog';
import { ProjectResourceSuggestionsDialog } from 'src/containers/ProjectResourceSuggestionsDialog/ProjectResourceSuggestionsDialog';
import { ProjectRuleDetailDrawer } from 'src/containers/ProjectRuleDetailDrawer/ProjectRuleDetailDrawer';
import { ProjectRuleOverviewDrawer } from 'src/containers/ProjectRuleOverviewDrawer/ProjectRuleOverviewDrawer';
import { ProjectSettingsDrawer } from 'src/containers/ProjectSettingsDrawer/ProjectSettingsDrawer';

export const ProjectOverlays: React.VFC = () => (
  <>
    <ProjectDiagramEntityDrawer />
    <ProjectDiagramCreateClassDrawer />
    <ProjectDiagramCreateRelationshipDrawer />
    <ProjectDiagramCreateSensitivePropertyGroupDrawer />
    <CreateMappingDialog />
    <ProjectResourceDialog />
    <ProjectResourceSuggestionsDialog />
    <ProjectSettingsDrawer />
    <ProjectRuleOverviewDrawer />
    <ProjectRuleDetailDrawer />
  </>
);
